import moment from 'moment';

import { truncate } from 'utils/strings';

import Trackers from 'app/collections/trackers';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';
import TrackerReport from 'app/models/tracker_report';
import TrackerStatusDropdownSelection from 'app/models/tracker_status_dropdown_selection';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import RequestReportView from 'app/views/request_report_view';
import SelectorView from 'app/views/selector_view';

import { List as ListView, Heading } from 'app/components/list/list';
import TrackingCodeHeadingView from 'app/components/list/item/headings/tracking_code';
import DateAndTimeHeadingView from 'app/components/list/item/headings/date_and_time';
import { DetailBlock } from 'app/components/list/object_details';
import ListSearchView from 'app/components/list/search';
import PageHeaderView from 'app/components/page_header';

import tmpl from './template';
import publicURLtemplate from './public_url';
import trackingDetailsTemplate from './tracking_details';

export const PublicURLView = Base.extend({
  compiledTemplate: publicURLtemplate,

  context() {
    const publicURL = this.model.get('public_url');
    return {
      publicURL,
      publicURLTruncated: truncate(publicURL, 33),
    };
  },
});

export const TrackingDetailsView = Base.extend({
  compiledTemplate: trackingDetailsTemplate,

  context() {
    return { trackingDetails: this.model.get('tracking_details').models.reverse() };
  },
});

export const buildHeadings = () => {
  return [
    new Heading({
      subView: m => new DateAndTimeHeadingView({ model: m }),
      display: 'Date',
      xsSize: 4,
      smSize: 2,
      wrapperClass: 'text-nowrap'
    }),
    new Heading({
      subView: m => new TrackingCodeHeadingView({ model: m }),
      display: 'Tracking Code',
      xsSize: 8,
      smSize: 4,
    }),
    new Heading({
      text: m => {
        const estDeliveryDate = moment(m.get('est_delivery_date') || '').utc();
        return estDeliveryDate.isValid() ? estDeliveryDate.format('YYYY-MM-DD') : '';
      },
      display: 'Est. Delivery Date',
      smSize: 2,
      xsHidden: true
    }),
    new Heading({
      text: m => m.get('status'),
      display: 'Status',
      wrapperClass: m => m ? 'monospace-font' : '',
      smSize: 2,
      xsHidden: true
    }),
  ];
};
export const buildShowDetails = () => {
  return {
    mainHeading: m => m.get('id'),
    detailBlocks: [
      new DetailBlock({
        heading: 'Public URL',
        subViews: [ m => new PublicURLView({ model: m }) ],
      }),
      new DetailBlock({
        heading: 'Tracking Details',
        subViews: [ m => new TrackingDetailsView({ model: m }) ],
      }),
    ],
  };
};

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'trackers',

  initialize({ apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATETIME });
    this.trackerStatusSelection = new TrackerStatusDropdownSelection({});
    this.collection = new Trackers([], {
      apiModeSelection: this.apiModeSelection,
      dateRange: this.dateRange,
      statusSelection: this.trackerStatusSelection,
    });

    this.listenTo(this.collection, 'update', this.render);

    this.addSubview('header', 'header', new PageHeaderView({
      name: 'Trackers', links: [
        { name: 'Docs', href: '/docs/api#trackers' },
        { name: 'Guide', href: '/tracking-guide' },
      ],
    }));
    this.addSubview('apiModeSelector', '#api_mode_selector', new SelectorView({ model: this.apiModeSelection }));
    this.addSubview('datepickers', '#tracker_daterange_pickers', new DatepickerRangeView({ model: this.dateRange }));
    this.addSubview('trackerStatusSelector', '#tracker_status_selector', new SelectorView({ model: this.trackerStatusSelection }));
    this.addSubview('requestTrackerReport', '#request_tracker_report', new RequestReportView({
      collection: this.collection, ReportClass: TrackerReport, dateRange: this.dateRange, apiModeSelection: this.apiModeSelection
    }));
    this.addSubview('search', '#tracker_search', new ListSearchView({
      collection: this.collection, placeholder: '(Tracking Code or ID)'
    }));
    this.addSubview('trackerList', '#tracker_list', new ListView({
      headings: buildHeadings(),
      collection: this.collection,
      noResultsMessage: 'No trackers have been purchased or generated matching your filter set.',
      showDetails: buildShowDetails(),
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/trackers/index.js